import script from "./VisitPayTotals.vue?vue&type=script&setup=true&lang=js"
export * from "./VisitPayTotals.vue?vue&type=script&setup=true&lang=js"

import "./VisitPayTotals.vue?vue&type=style&index=0&id=4bf3e2be&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bf3e2be"]])

export default __exports__